<template>
    <div class="alert" :class="'alert--' + type">
        <div class="type">
            <i class="icon" :class="'ion-md-' + iconForType"></i>
        </div>
        <div>
            <h4>{{ title }}</h4>
            <ul>
                <li v-for="(item, key) in formattedCopy">
                    <span v-for="(i) in item">{{ i }}</span> 
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                default: null,
            },
            copy: {
                default: false,
            },
            type: {
                default: 'info',
            }
        },
        data () {
            return {

            }
        },
        computed: {
            formattedCopy(){
                return this.copy;
            },
            iconForType(){
                switch( this.type ) {
                    case 'success':
                        return "checkmark-circle";
                        break;
                    case 'error':
                        return "close-circle";
                        break;
                    case 'info':
                        return "information-circle";
                        break;
                    default:
                        return "information-circle";
                }
            }
        },
        methods:{
        }
    }
</script>